import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base Layout
          "flex h-12 w-full appearance-none px-5 py-2",
          // Shape & Borders (Borderless / Soft Surface)
          "rounded-full border-none bg-slate-100/50 shadow-none",
          // Typography
          "text-base md:text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium",
          // Colors
          "text-[var(--athr-text-primary)] placeholder:text-slate-400",
          // Interactive States
          "transition-all duration-300 ease-spring-3",
          "focus:bg-white focus:ring-4 focus:ring-[rgba(0,74,198,0.08)] focus:shadow-sm",
          "focus-visible:bg-white focus-visible:ring-4 focus-visible:ring-[rgba(0,74,198,0.08)] focus-visible:shadow-sm",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
